module.exports = __webpack_public_path__ + "images/home/index/values-timeline-screenshot-269fa7f098bccbb4364bfeb3b7cee199.png";